import React from "react";
import { Nav, NavItem, NavLink } from "shards-react";

import Notifications from "./Notifications";
import UserActions from "./UserActions";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { wikilogout } from "../../../../../../actions/auth";
import Errors from "../../../../views/Errors";
import Spinner from "../../../../../layout-spinner/Spinner";

function NavbarNav({ auth: { wikiloading, wikiuser }, wikilogout }) {
  
  return ( wikiloading ? <Spinner /> : wikiloading === false && wikiuser !== null ?
    <React.Fragment>
    <Nav navbar className="md-mr-3 ml-auto navItems">
            <NavItem className = "mt-2">
                  {typeof wikiuser !== 'undefined' && wikiuser !==null && wikiuser.workspaceName !== null ? wikiuser.workspaceName : console.log('nada')}
            </NavItem>
              <NavItem>
              <NavLink className = "text-center mt-n2 mr-md-2" onClick={wikilogout} href='#!'>
              {(
                <div
                  className="d-inline-block item-icon-wrapper"
                  dangerouslySetInnerHTML={{ __html: '<i class="material-icons">logout</i>' }}
                />)}
              {<span>{" Logout"}</span>}
                </NavLink>
            </NavItem>
    {/* <Notifications /> */}
    {/* <UserActions /> */}
  </Nav>
  </React.Fragment> : <Errors />
  )
}


NavbarNav.propTypes = {
  wikilogout: PropTypes.func.isRequired,
  wikiauth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(
  mapStateToProps,
  { wikilogout }
)(NavbarNav);



